var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.71 4.428C6.568 4.428 3.194 7.81 3.194 12s3.374 7.572 7.518 7.572c1.767 0 3.39-.613 4.674-1.642a1.044 1.044 0 0 1 1.306 1.63 9.53 9.53 0 0 1-5.98 2.1c-5.31 0-9.606-4.328-9.606-9.66s4.297-9.66 9.606-9.66c4.903 0 8.943 3.691 9.532 8.455l1.019-1.018a1.044 1.044 0 0 1 1.476 1.477l-2.953 2.954a1.044 1.044 0 0 1-1.477 0l-2.954-2.954a1.044 1.044 0 0 1 1.477-1.477l1.348 1.348c-.431-3.776-3.617-6.697-7.468-6.697",
  clipRule: "evenodd"
})));
export default SvgRefresh;